<template>
  <main class="p20 bg-white main stock">
    <div class="mt20 mb20">
      <span class="title1">质检异常</span>
    </div>
    <div class="search-one" style="margin-top: 70px;">
      以下为在入库质检时发现的异常，请及时处理！
    </div>
    <div class="search-one mt20">
      <div class="search-item">
        快递单号
        <Input class='ml10 mr20 w200' v-model="screen_data.waybill_code" placeholder="请输入运单号" />
        子账户编号
        <Input class='ml10 mr20 w200' v-model="screen_data.client_code" placeholder="请输入运单号" />
        状态
        <Select v-model="screen_data.exception_status" class="w200 mr20">
          <Option v-for="(option, index) in statusList" :value="option.value" :key="index">{{option.label}}
          </Option>
        </Select>
      </div>
      <div class="search-item">
        入库时间
        <DatePicker @on-change="sDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        确认时间
        <DatePicker @on-change="sUpdateDateChange" type="date" class='ml10 mr20 w200'></DatePicker>-
        <DatePicker @on-change="eUpdateDateChange" type="date" class='ml10 mr20 w200'></DatePicker>
        <button class="ivu-btn ivu-btn-primary fr" @click="search">搜索</button>
      </div>

    </div>
    <Table :loading="loading" class="mt20" border :columns="table_data.columns" :data="table_data.data">
      <template slot-scope="{ row, index }" slot="oprate">
        <a v-if="row.exception_status==0" @click="getDetail(row,index,true)" class="blue mr10">确认</a>
        <a v-else @click="getDetail(row,index,false)" class="blue mr10">查看</a>
      </template>
    </Table>
    <Paging :page-data="page_data" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>

    <Modal :title="'包裹详情-'+details.waybill_code" v-model="show_detail" width="1100">
      <div class="detail-info">
        <div class="search-one" style="padding: 10px;margin: 10px 0 20px;">
          注意：点击废弃时，将自动产生一个废弃单！
        </div>

        <div v-for="(item,index) in abnormal" :key="item.in_bill_no" class="mt10">
          <div class="bg-orange overflow-h">
            <span class="fl">入库编号{{item.sequence}}：{{item.in_bill_no}}</span>
            <span class="fr fcfff">异常包裹，请选择处理方式</span>
          </div>
          <div class="bg-gray p10">
            <div class="name">#{{index+1}} {{item.sku}}/{{item.product_name}}/{{item.count}}个</div>
            <div class="overflow-h">
              <!-- 1 -->
              <div class="check-info">
                <div v-for="(v,i) in item.checkResults" :key="i" class="item">
                  <span class="cname">{{v.check_item}}</span>
                  <span>
                    <RadioGroup v-model="v.is_pass">
                      <Radio :label="'true'" disabled>符合</Radio>
                      <Radio :label="'false'" disabled>不符合</Radio>
                    </RadioGroup>
                  </span>
                </div>

              </div>

              <!-- 图片和备注 -->
              <div class="image-info fl">
                <div class="img-box" v-if="item.checkImages.length">
                  <!-- <img v-for="(img,idx) in item.checkImages" :key="idx+1" :src="img.image_url" /> -->
                  <span class="item-img mr10 fl" v-for="(img,idx) in item.image_arr" :key="img">
                    <el-image
                        style="width: 100px; height: 100px;"
                        :src="img"
                        :preview-src-list="item.image_arr">
                      </el-image>
                  </span>
                </div>
                <div class="remark p10">
                  <p>预报备注信息：</p>
                  <p>{{item.remark || '无'}}</p>
                </div>
                <div v-if="is_confirm" class="mt20 mt20 tr">
                  <RadioGroup v-model="item.confirm_type">
                    <Radio :label="1" class="red">废弃</Radio>
                    <Radio :label="0" class="green">正常入库</Radio>
                  </RadioGroup>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div v-if="is_confirm" class="center mt20">
          <span class="purple-btn" @click="save">提交</span>
          <span class="b-btn" @click="show_detail = false">取消</span>
        </div>

        <!-- 已入库 -->
        <div v-for="(item,index) in normal" :key="index">
          <div class="bg-green overflow-h p10 mt20">
            <span class="fl">入库编号{{item.sequence}}：{{item.in_bill_no}}</span>
            <span class="fr fcfff">正常包裹，无需处理</span>
          </div>
          <div class="bg-gray p10">
            <div class="name">#{{index+1}} {{item.sku}}/{{item.product_name}}/{{item.count}}个</div>
            <div class="overflow-h">
              <!-- 1 -->
              <div class="check-info">
                <div v-for="(v,i) in item.checkResults" :key="i" class="item">
                  <span class="cname">{{v.check_item}}</span>
                  <span>
                    <RadioGroup v-model="v.is_pass">
                      <Radio :label="'true'" disabled>符合</Radio>
                      <Radio :label="'false'" disabled>不符合</Radio>
                    </RadioGroup>
                  </span>
                </div>
              </div>

              <!-- 图片和备注 -->
              <div class="image-info fl">
                <div v-if="item.checkImages.length" class="img-box">
                  <!-- <img v-for="(img,idx) in item.checkImages" :key="idx" :src="img.image_url" /> -->
                  <span class="item-img mr10 fl" v-for="(img,idx) in item.image_arr" :key="idx+1">
                    <el-image
                        style="width: 100px; height: 100px;"
                        :src="img"
                        :preview-src-list="item.image_arr">
                      </el-image>
                  </span>
                </div>
                <div class="remark p10">
                  <p>预报备注信息：</p>
                  <p>{{item.remark|| '无'}}</p>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <div slot="footer" class="center">
      </div>
    </Modal>
  </main>

</template>

<script>
  import Paging from '@/components/common/paging'

  export default {
    components: {
      Paging
    },
    data() {
      return {
        is_preview: localStorage.getItem("is_preview") == 'true' ? true : false, //是否打印预览
        show_detail: false,
        client_code: '', //客户编号
        is_confirm: false,//是否是确认
        statusList: [{
          value: '',
          label: '全部'
        }, {
          value: 0,
          label: '待确认'
        }, {
          value: 1,
          label: '已确认'
        }, {
          value: -1,
          label: '直接废弃'
        }],
        table_data: { //列表数据
          columns: [],
          data: []
        },
        loading: true, //是否加载中
        screen_data: { //传入接口的搜索条件
          warehouse_id: '',
          pageNum: 1,
          pageSize: 10,
        },
        page_data: { //分页数据
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 8 //页面最多显示几个分页组
        },
        date: '', //当前日期:时分秒
        details: {}, //当前处理的数据
        normal: [], //正常的数据
        abnormal: [], //不正常的数据
      }
    },
    methods: {
      save() { //处理异常
        let abnormal = [...this.abnormal]
        //判断是否选中
        let checkArr = abnormal.map(v => {
          return v.confirm_type
        })
        let state = checkArr.some(v => v == undefined);
        if (state) {
          this.$Message.info('请先处理异常')
          return
        }
        let params = this.abnormal.map(v => {
          return {
            confirm_type: v.confirm_type,
            count: v.count,
            sku: v.sku,
            in_bill_no: v.in_bill_no
          }
        })
        console.log(params)
        this.$axios.post("/warehouse/waybill/exception/confirm?in_bill_no=" + params[0].in_bill_no, params, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res => {
          if (res.success) {
            this.$Message.success('确认成功')
            this.show_detail = false;
            this.getList()
          }
        })
      },
      getDetail(item,index,is_confirm) {
        this.is_confirm = is_confirm;//是否是确认
        this.details = this.table_data.data[index];
        this.$axios.get("/warehouse/waybill/exception/detail?waybill_code=" + item.waybill_code).then(res => {
          if (res.data && res.data.length) {
            res.data.forEach(v => {
              //图片数组
              v.image_arr = []
              if(v.checkImages && v.checkImages.length){
                v.image_arr = v.checkImages.map(val=>{
                  return val.image_url
                })
              }
              if (v.checkResults && v.checkResults.length) {
                v.checkResults.forEach(val => {
                  val.is_pass += ''
                })
              }
            })
            console.log(res.data)
            this.normal = res.data.filter(v => {
              if (v.check_status == 0) {
                return v
              }
            })
            this.abnormal = res.data.filter(v => {
              if (v.check_status == 1) {
                return v
              }
            })
          }
          this.show_detail = true;
          console.log(this.abnormal)
        })
      },
      init() {
        this.table_data.columns = this.setColumns();
      },
      sDateChange(e) {
        if (e) {
          this.screen_data.create_start_date = e + ' 23:59:59'
        } else {
          this.screen_data.create_start_date = ''
        }
      },
      eDateChange(e) {
        if (e) {
          this.screen_data.create_end_date = e + ' 00:00:00'
        } else {
          this.screen_data.create_end_date = ''
        }
      },
      sUpdateDateChange(e) {
        if (e) {
          this.screen_data.confirm_start_date = e + ' 23:59:59'
        } else {
          this.screen_data.confirm_start_date = ''
        }
      },
      eUpdateDateChange(e) {
        if (e) {
          this.screen_data.confirm_end_date = e + ' 00:00:00'
        } else {
          this.screen_data.confirm_end_date = ''
        }
      },
      /*
       * 搜索
       */
      search() {
        this.screen_data.pageNum = 1;
        this.getList();
      },
      /*
       * 分页
       */
      setPage(page) {
        this.screen_data.pageNum = this.page_data.pageIndex = page;
        this.getList();
      },
      chooseSize(size) {
        this.page_data.pageSize = this.screen_data.pageSize = size;
        let p = Math.ceil(this.page_data.dataTotal / this.page_data.pageSize);
        if (this.page_data.pageIndex > p) {
          this.page_data.pageIndex = this.screen_data.pageNum = p;
        }
        this.getList();
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/warehouse/waybill/exception/list", {
          params: this.screen_data
        }).then(res => {
          this.loading = false;
          if (res.success && res.data) {
            this.table_data.data = res.data;
          }
          this.page_data.pageTotal = res.pageTotal;
          this.page_data.dataTotal = res.totalSize;
        })
      },
      setColumns() {
        let arr = [];
        arr = [{
          title: '序号',
          key: 'discard_bill_no',
          minWidth: 60,
          render: (h, params) => {
            return h('span', params.index + 1)
          }
        }, {
          title: '快递单号',
          key: 'waybill_code',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '入库库房',
          key: 'warehouse_name',
          tooltip: true,
          minWidth: 200,
        }, {
          title: '子账户编号',
          key: 'client_code',
          tooltip: true,
          minWidth: 200,
        }, {
          title: 'UPC数',
          key: 'sku_count',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '商品数',
          key: 'product_count',
          tooltip: true,
          minWidth: 120,
        }, {
          title: '状态',
          key: 'exception_status',
          minWidth: 100,
          render: (h, params) => {
            let status = params.row.exception_status;
            let color = '';
            let txt = '';
            if (status == 0) {
              color = '#D9001B'
              txt = '待确认'
            } else if (status == 1) {
              color = '#4acd40'
              txt = '已确认'
            }else if(status == -1){
              color = '#00007f'
              txt = '直接废弃'
            }
            return h('span', {
              style: {
                color: color
              },
            }, txt)
          }
        }, {
          title: '入库时间',
          key: 'create_date',
          minWidth: 170,
          tooltip: true,
        }, {
          title: '确认时间',
          key: 'update_date',
          minWidth: 170,
          tooltip: true,
        }, {
          title: '操作',
          minWidth: 180,
          slot: 'oprate'
        }];
        return arr;
      },
    },
    created() {
      $.getScript("static/js/LodopFuncs.js", function(res) {
        checkPrintLoad(function() {
          LODOP = getCLodop();
        })
      })
      this.screen_data.warehouse_id = localStorage.getItem('warehouse_id');
      this.screen_data.biz_type = 2;
      if (this.screen_data.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
      this.init();
    }
  }
</script>

<style lang="scss" scoped>
  .ivu-modal-wrap,.ivu-modal-mask{
    z-index: 99 !important;
  }
  .stock .w200 {
    width: 200px !important;
  }

  .btn-scan:visited,
  .btn-scan:active,
  .btn-scan:focus {
    color: #ffffff;
  }

  .btn-scan {
    line-height: 40px;
    margin-top: 40px;
  }

  .bg-orange {
    background-color: #f59a23;
    padding: 10px;
  }

  .bg-green {
    background-color: #48c34f;
  }

  .fcfff {
    color: #FFFFFF;
  }

  .bg-gray {
    background-color: #f6f8f9;

    .name {}
  }

  .check-info {
    width: 400px;
    float: left;
    margin-right: 20rpx;

    .item {
      padding: 5px 10px;
      border: 1px solid #ccc;
      color: #6A7995;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      border-radius: 4px;
      width: 90%;

      span {
        display: inline-block;
      }

      .cname {
        width: 160px;
      }
    }
  }

  .image-info {
    width: 600px;

    .img-box {
      overflow: hidden;
      img {
        width: 100px;
        height: 100px;
        margin-right: 10px;
      }
    }

    .remark {
      border: 1px solid #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/tuihuozhijian/zhijianyichang/list.vue